import { PRIZE_METRIC_LABELS } from '@affily/shared/constants';
import { formatCount } from '@affily/shared/money';

const VIDEO_UNITS = {
  video_views: ['view', 'views'],
  video_shares: ['share', 'shares'],
  video_likes: ['like', 'likes'],
  video_comments: ['comment', 'comments'],
};

/** The program's name for an action, falling back to its key. */
const eventName = (events, key) => events?.find((e) => e.key === key)?.name ?? key;

/** "Most views on one video", "First video to 100,000 views", or "Most viewings" for a counted action. */
export function prizeMeasure(prize, events = []) {
  if (prize.kind === 'first_to') {
    const [, many] = VIDEO_UNITS[prize.metric] ?? ['', ''];
    return `First video to ${formatCount(prize.threshold ?? 0)} ${many}`;
  }
  if (prize.metric === 'event_count') {
    const name = eventName(events, prize.eventKey);
    return `Most ${name.toLowerCase()}${/s$/i.test(name) ? '' : 's'}`;
  }
  return PRIZE_METRIC_LABELS[prize.metric] ?? prize.metric;
}

/** "3 viewings", "40,000 views". */
export function prizeValue(prize, value, events = []) {
  if (value === null || value === undefined) return '—';
  if (prize.metric === 'event_count') {
    const name = eventName(events, prize.eventKey).toLowerCase();
    return `${formatCount(value)} ${name}${value === 1 || /s$/.test(name) ? '' : 's'}`;
  }
  const [one, many] = VIDEO_UNITS[prize.metric] ?? ['', ''];
  return `${formatCount(value)} ${value === 1 ? one : many}`;
}

export const ordinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] ?? s[v] ?? s[0]}`;
};

export const COMPETITION_STATUS_LABELS = {
  upcoming: 'Starts soon',
  running: 'Running',
  ended: 'Ended',
};

/** ISO → the value a datetime-local input wants, in the viewer's own time zone. */
export function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}

export const fromLocalInput = (value) => (value ? new Date(value).toISOString() : null);
